import { render, staticRenderFns } from "./TableItems.vue?vue&type=template&id=026d7056&"
import script from "./TableItems.vue?vue&type=script&lang=ts&"
export * from "./TableItems.vue?vue&type=script&lang=ts&"
import style0 from "./TableItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports